// const BASE_URL = "https://localhost:7231/api/Designation";


import { BASE_URL } from "../config";

// /api/Designation/designations
export const getAllDesignation = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Designation/designations`);
    if (!response.ok) {
      throw new Error("Failed to fetch designations");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching designations:", error);
    throw error;
  }
};